// extracted by mini-css-extract-plugin
export default {"introScreen":"Intro_introScreen__mY12u","textContainer":"Intro_textContainer__NybFK","word":"Intro_word__RCrpu","loaderLine":"Intro_loaderLine__xYmq0"};